import type { CookieConsentConfig } from "vanilla-cookieconsent";

const GA_ID = "G-LG34MT38GZ";

declare global {
  interface Window {
    dataLayer?: any[];
    gtag?: (...args: any[]) => void;
  }
}

function loadGA() {
  if (document.getElementById("ga-script")) return;
  const script = document.createElement("script");
  script.id = "ga-script";
  script.async = true;
  script.src = `https://www.googletagmanager.com/gtag/js?id=${GA_ID}`;
  document.head.appendChild(script);
  window.dataLayer = window.dataLayer || [];
  function gtag(...args: any[]) {
    window.dataLayer!.push(args);
  }
  window.gtag = gtag as any;
  gtag("js", new Date());
  gtag("config", GA_ID);
}

function removeGA() {
  const script = document.getElementById("ga-script");
  if (script) script.remove();
  const cookies = document.cookie.split(";");
  for (const cookie of cookies) {
    const name = cookie.split("=")[0].trim();
    if (name.startsWith("_ga") || name === "_gid") {
      document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/; domain=.${window.location.hostname}`;
      document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;`;
    }
  }
}

export const cookieConsentConfig: CookieConsentConfig = {
  categories: {
    necessary: {
      enabled: true,
      readOnly: true,
    },
    analytics: {
      autoClear: {
        cookies: [{ name: /^_ga/ }, { name: "_gid" }],
      },
      services: {
        ga: {
          label: "Google Analytics",
          onAccept: loadGA,
          onReject: removeGA,
        },
      },
    },
  },

  guiOptions: {
    consentModal: {
      layout: "box inline",
      position: "bottom left",
    },
  },

  language: {
    default: "en",
    translations: {
      en: {
        consentModal: {
          title: "Cookie preferences",
          description:
            "We use Google Analytics to understand how this platform is used. Analytics data is processed by Google in the United States. No analytics cookies are set until you choose.",
          acceptAllBtn: "Accept all",
          acceptNecessaryBtn: "Reject all",
          showPreferencesBtn: "Manage preferences",
        },
        preferencesModal: {
          title: "Cookie preferences",
          closeIconLabel: "Close preferences",
          acceptAllBtn: "Accept all",
          acceptNecessaryBtn: "Reject all",
          savePreferencesBtn: "Save preferences",
          sections: [
            {
              title: "Strictly necessary",
              description:
                "Authentication cookies required for the platform to function. Cannot be disabled.",
              linkedCategory: "necessary",
            },
            {
              title: "Analytics",
              description:
                "We use Google Analytics (Google LLC, US) to understand how users interact with the platform. These cookies collect anonymized usage data.",
              linkedCategory: "analytics",
              cookieTable: {
                headers: {
                  name: "Cookie",
                  domain: "Domain",
                  description: "Purpose",
                  expiration: "Duration",
                },
                body: [
                  {
                    name: "_ga",
                    domain: location.hostname,
                    description: "Distinguishes unique visitors",
                    expiration: "2 years",
                  },
                  {
                    name: "_ga_*",
                    domain: location.hostname,
                    description: "Stores session state",
                    expiration: "2 years",
                  },
                  {
                    name: "_gid",
                    domain: location.hostname,
                    description: "Distinguishes visitors (24h)",
                    expiration: "24 hours",
                  },
                ],
              },
            },
          ],
        },
      },
    },
  },
};
